import { z } from 'zod';

export const filesListSearch = z.object({
  page: z.number().int().min(0).catch(0),
  count: z.number().int().min(10).max(500).catch(20),
  sort: z.string().optional(),
  filters: z.record(z.array(z.string())).optional(),
  quickFilter: z.string().catch(''),
});

export type FilesListSearch = z.infer<typeof filesListSearch>;

export interface FileListParams {
  page?: number;
  count?: number;
  sort?: string;
  filter?: string;
  isArchived?: boolean;
}
